<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
    :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
    :selection="{ mode: displayMode ? 'multiple' : 'single' }"
    :show-borders='true'
    :style="{ height: localHeight, width: localWidth }"
    :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
    :summary="summary"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @selection-changed="onMultiSelectionChanged"
    @cell-prepared="onCellPrepared"
    @content-ready="onContentReady"
    @cell-click="onSelectionChanged")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import { mapGetters } from 'vuex';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';
import { getDateString } from '@/helpers';

export default {
  name: 'KdmStrewing',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    displayMode: {
      type: Boolean,
      default: false,
    },
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
    track: {
      type: Object,
      default () {
        return {};
      },
    },
    colors: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'Begin',
        caption: 'Начало',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 150,
      }, {
        dataField: 'End',
        caption: 'Конец',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 150,
      }, {
        dataField: 'MileageKm',
        caption: 'Пробег, км',
      }, {
        dataField: 'AvgSpeed',
        caption: 'Средняя скорость',
        alignment: 'center',
      }],
      summaryColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'MileageKm',
        name: 'MileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'AvgSpeed',
        name: 'AvgSpeed',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      summary: null,
      rowClick: null,
      reportSummary: [],
      index: 0,
      lastSelectedColor: '',
    };
  },
  computed: {
    ...mapGetters('preferences', ['tracksColors']),
    indexLastSelectedColor () {
      return this.tracksColors.findIndex(item => item === this.lastSelectedColor);
    },
  },
  watch: {
    reportData (value) {
      this.rowClick = null;
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      }
      this.getSummary();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
    this.getSummary();
  },
  methods: {
    onCellPrepared (e) {
      if (e.rowType === 'data' && e.column.type === 'selection' && e.value) {
        e.cellElement.style.backgroundColor = e.data.Color;
      }
    },
    async onMultiSelectionChanged (e) {
      if (this.displayMode) {
        const timeZone = Number(this.reportData.TimeZone.split(':', 3)[0]);
        const selectedNumRows = [];
        const periods = e.selectedRowsData.map((item, index) => {
          selectedNumRows.push(item.RowNum);
          const newItem = item;
          if (e.currentSelectedRowKeys.length === 1) {
            newItem.Color = newItem.Color ? newItem.Color : this.tracksColors[(this.indexLastSelectedColor + 1) % this.tracksColors.length];
          } else {
            newItem.Color = newItem.Color ? newItem.Color : this.tracksColors[(this.indexLastSelectedColor + 1 + index) % this.tracksColors.length];
          }
          const newEvent = {
            begin: new Date((item.Begin - timeZone * 3600) * 1000),
            end: new Date((item.End - timeZone * 3600) * 1000),
            color: newItem.Color,
            solid: true,
            width: 3,
          };
          return newEvent;
        });
        if (e.currentSelectedRowKeys.length) {
          this.lastSelectedColor = e.currentSelectedRowKeys[e.currentSelectedRowKeys.length - 1]?.Color || '';
        }
        this.reportData.Data.Data.Rows = this.reportData.Data.Data.Rows.map((item, index) => {
          if (selectedNumRows.includes(item.RowNum)) {
            return { ...item, Color: e.selectedRowsData.find(row => row.RowNum === item.RowNum).Color };
          }
          return { ...item, Color: '' };
        });
        await this.$store.dispatch('tracks/updateParts', { id: this.track.Id, visible: !!periods.length, periods });
        let reportText = `[${this.track.name}] Отчёт по событиям. `;
        if (e.selectedRowKeys.length === 0) {
          reportText += 'Снят выбор со всех участков трека';
        } else if (e.selectedRowKeys.length === this.reportData.Data.Data.Rows.length) {
          reportText += 'Выбраны все участки трека';
        } else if (e.currentSelectedRowKeys.length) {
          reportText += `Выбран участок трека с ${getDateString((e.currentSelectedRowKeys[0].Begin - timeZone * 3600) * 1000)} по ${getDateString((e.currentSelectedRowKeys[0].End - timeZone * 3600) * 1000)}`;
        } else if (e.currentDeselectedRowKeys.length) {
          reportText += `Снят выбор с участка трека с ${getDateString((e.currentDeselectedRowKeys[0].Begin - timeZone * 3600) * 1000)} по ${getDateString((e.currentDeselectedRowKeys[0].End - timeZone * 3600) * 1000)}`;
        }
        this.$store.dispatch('tracking/track', {
          idOrType: 'OpenReportEvent',
          reportText,
        });
        if (!e.currentDeselectedRowKeys.length && e.currentSelectedRowKeys.length) {
          const lastCurrentSelectedRowKey = e.currentSelectedRowKeys[e.currentSelectedRowKeys.length - 1];
          global.mainMap.fitBounds([
            [lastCurrentSelectedRowKey.BeginLocationLatitude, lastCurrentSelectedRowKey.BeginLocationLongitude],
            [lastCurrentSelectedRowKey.EndLocationLatitude, lastCurrentSelectedRowKey.EndLocationLongitude],
          ]);
        }
      }
    },
    onSelectionChanged (item) {
      if (item.rowType === 'data') {
        if (this.reportData.BuildTrack && this.track.Id) {
          if (!(this.rowClick && this.rowClick.Begin === item.data.Begin && this.rowClick.End === item.data.End)) {
            const timeZone = Number(this.reportData.TimeZone.split(':', 3)[0]);
            const periods = [[new Date((item.data.Begin - timeZone * 3600) * 1000), new Date((item.data.End - timeZone * 3600) * 1000)]];
            this.$store.dispatch('tracks/updateTrack', { reportId: this.track.Id, secondColor: this.colors.alternative.hex, periods });
            this.reportData.periodsPartTrack = periods;
            this.rowClick = {
              Begin: item.data.Begin,
              End: item.data.End,
            };
          }
        }
        if (item.column.dataField === 'Begin' || item.column.dataField === 'BeginLocation') {
          const value = {
            lat: item.data.BeginLocationLatitude,
            lng: item.data.BeginLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
        if (item.column.dataField === 'End' || item.column.dataField === 'EndLocation') {
          const value = {
            lat: item.data.EndLocationLatitude,
            lng: item.data.EndLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
      }
    },

    convertSummaryData (data) {
      const rows = [];
      data.Data.Data.forEach((_row, i) => {
        const row = _row;
        row.RowNum = i + 1;
        row.MileageKm = row.SumMileageKm;
        delete row.SumMileageKm;
        rows.push(row);
      });
      this.reportSummary = rows;
    },

    getSummary () {
      if (!this.reportData.IsSummary) {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              const totalValue = this.reportData.Data.Data[`Sum${options.name}`];
              if (totalValue !== undefined) {
                value.totalValue = totalValue;
              }
            }
          },
          totalItems: this.summaryColoumn,
        };
      } else {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              if (options.groupIndex === undefined) {
                const totalValue = this.reportData.Data[`Sum${options.name}`];
                if (totalValue !== undefined) {
                  value.totalValue = totalValue;
                }
                this.index = 0;
              } else {
                value.totalValue = this.reportData.Data.Data[this.index] ? this.reportData.Data.Data[this.index][`Sum${options.name}`] : undefined;
                if (options.name === 'AvgSpeed') {
                  this.index += 1;
                }
              }
            }
          },
          totalItems: this.summaryColoumn,
          groupItems: this.summaryColoumn.filter(x => x.column !== 'RowNum'),
        };
      }
    },
  },
};
</script>
